import React from 'react';
import { Lock, Star, CheckCircle } from 'lucide-react';

export const ExclusiveView: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10 animate-fadeIn">
      <div className="bg-yellow-400 text-black font-black text-center py-3 sm:py-4 rounded-xl sm:rounded-2xl mb-6 shadow-lg animate-pulse text-sm sm:text-base">
        COMEINGGG SOOOON 😀, THIS SECTION IS UNDER MAINTAINANCE
      </div>
      <div className="text-center mb-8 sm:mb-10">
        <h2 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Premium Resources</h2>
        <p className="text-sm sm:text-lg text-gray-600 max-w-2xl mx-auto">
          Unlock the ultimate preparation kit curated by BPSC toppers and experienced faculty.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
        {/* Free Plan */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-8 flex flex-col opacity-60">
            <h3 className="text-lg sm:text-xl font-bold text-gray-400 mb-2">Basic Access</h3>
            <p className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">Free</p>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8 flex-1">
                <li className="flex items-center text-gray-500 text-sm sm:text-base"><CheckCircle size={16} className="mr-2 sm:w-[18px] sm:h-[18px]" /> Public Notifications</li>
                <li className="flex items-center text-gray-500 text-sm sm:text-base"><CheckCircle size={16} className="mr-2 sm:w-[18px] sm:h-[18px]" /> Previous Year Papers</li>
                <li className="flex items-center text-gray-500 text-sm sm:text-base"><CheckCircle size={16} className="mr-2 sm:w-[18px] sm:h-[18px]" /> General News</li>
            </ul>
            <button className="w-full py-2.5 sm:py-3 rounded-xl border border-gray-300 text-gray-500 font-medium cursor-not-allowed text-sm sm:text-base">Current Plan</button>
        </div>

        {/* Pro Plan (Main Focus) */}
        <div className="bg-white rounded-2xl shadow-xl border-2 border-yellow-400 p-6 sm:p-8 flex flex-col relative transform md:-translate-y-4">
            <div className="absolute top-0 right-0 bg-yellow-400 text-red-900 text-[10px] sm:text-xs font-bold px-2 sm:px-3 py-1 rounded-bl-lg rounded-tr-lg">POPULAR</div>
            <h3 className="text-lg sm:text-xl font-bold text-red-600 mb-2">Achiever's Batch</h3>
            <div className="flex items-baseline mb-4 sm:mb-6">
                <p className="text-3xl sm:text-4xl font-extrabold text-gray-900">₹499</p>
                <p className="text-xs sm:text-sm text-gray-500 ml-2">/ one time</p>
            </div>
            
            <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8 flex-1">
                <li className="flex items-center text-gray-800 font-medium text-sm sm:text-base"><Star size={16} className="mr-2 text-yellow-500 fill-yellow-500 sm:w-[18px] sm:h-[18px]" /> Exclusive Cut-off Analysis</li>
                <li className="flex items-center text-gray-800 font-medium text-sm sm:text-base"><Star size={16} className="mr-2 text-yellow-500 fill-yellow-500 sm:w-[18px] sm:h-[18px]" /> 15 Full Length Mock Tests</li>
                <li className="flex items-center text-gray-800 font-medium text-sm sm:text-base"><Star size={16} className="mr-2 text-yellow-500 fill-yellow-500 sm:w-[18px] sm:h-[18px]" /> Personal Mentorship</li>
                <li className="flex items-center text-gray-800 font-medium text-sm sm:text-base"><Star size={16} className="mr-2 text-yellow-500 fill-yellow-500 sm:w-[18px] sm:h-[18px]" /> Priority WhatsApp Support</li>
            </ul>
            
            <button className="w-full py-2.5 sm:py-3 rounded-xl bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-bold shadow-lg transition transform hover:scale-105 text-sm sm:text-base">
                Unlock Now
            </button>
        </div>

         {/* Blurred Content Preview */}
         <div className="bg-gray-50 rounded-2xl border border-gray-200 p-5 sm:p-6 flex flex-col justify-center items-center relative overflow-hidden">
             {/* Fake Content Behind Blur */}
             <div className="absolute inset-0 p-5 sm:p-6 filter blur-sm opacity-50 select-none pointer-events-none">
                 <h4 className="font-bold text-base sm:text-lg mb-2">Secret Strategy for 100+ Marks</h4>
                 <p className="text-xs sm:text-sm">Lorem ipsum dolor sit amet...</p>
                 <div className="h-3 sm:h-4 bg-gray-200 w-3/4 mt-4 rounded"></div>
                 <div className="h-3 sm:h-4 bg-gray-200 w-full mt-2 rounded"></div>
             </div>
             
             <div className="relative z-10 text-center">
                 <div className="bg-white p-3 sm:p-4 rounded-full shadow-lg inline-block mb-3 sm:mb-4">
                     <Lock size={24} className="text-gray-400 sm:w-8 sm:h-8" />
                 </div>
                 <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-1 sm:mb-2">Premium Content Locked</h3>
                 <p className="text-xs sm:text-sm text-gray-500 mb-3 sm:mb-4">Join the Achiever's Batch to view this content.</p>
             </div>
         </div>
      </div>
    </div>
  );
};
